import React from "react";
import T from "prop-types";

export default function DetailTable({ children }) {
  return (
    <table className="table table-condensed">
      <tbody>{children}</tbody>
    </table>
  );
}

DetailTable.propTypes = {
  children: T.oneOfType([T.element, T.arrayOf(T.element)])
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/DetailTable/DetailTable.jsx